import axios from 'axios';
import { getIdemDeviceToken } from './idemSession';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

// Inject auth token into every request when present.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('idemgo_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public (no auth) client for hosted-flow uploads.
export const publicApi = axios.create({ baseURL: `${BACKEND}/api` });

// idem lab client that carries the paired device token when available.
export const idemApi = axios.create({ baseURL: `${BACKEND}/api` });
idemApi.interceptors.request.use((config) => {
  const token = getIdemDeviceToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
